import ErrorPage from './views/errorPage';
import Notmatch from './views/notMatch';
import home from './views/home';

export default [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/account_error',
    name: 'account_error',
    component: ErrorPage,
    meta: {
      title: '账号异常'
    }
  },
  {
    path: '/not_match',
    name: 'not_match',
    component: Notmatch,
    meta: {
      title: '账号不符合'
    }
  },
  {
    path: '/my_awards',
    name: 'my_awards',
    component: () => import('./views/awards.vue'),
    meta: {
      title: '奖励记录'
    }
  },
  {
    path: '/rule',
    name: 'rule',
    component: () => import('./views/rule.vue'),
    meta: {
      title: '活动规则'
    }
  }
];
